// Константы для расчёта сечения кабеля

// Удельные сопротивления при 20°C (Ом·мм²/м)
export const RESISTIVITY = {
  copper: 0.0175,
  aluminum: 0.0280,
} as const;

// Температурные коэффициенты (1/°C)
export const TEMP_COEFFICIENT = {
  copper: 0.00393,
  aluminum: 0.00403,
} as const;

// Допустимые потери напряжения (%)
export const MAX_VOLTAGE_LOSS = {
  power: 5.0,
  lighting: 2.5,
} as const;

// Реактивное сопротивление воздушных линий (Ом/км)
export const X0_OVERHEAD = 0.35;

// Стандартные сечения (мм²)
export const STANDARD_SECTIONS = [
  1.5, 2.5, 4, 6, 10, 16, 25, 35, 50, 70, 95, 120, 150, 185
] as const;

// Номинальные напряжения (В)
export const NOMINAL_VOLTAGES = {
  singlePhase: 230,
  threePhase: 400,
} as const;

// Рабочая температура изоляции (°C)
export const INSULATION_MAX_TEMP = {
  pvc: 70,
  xlpe: 90,
  paper: 80,
} as const;

// Базовая температура окружающей среды (°C)
export const BASE_AMBIENT_TEMP = {
  air: 30,
  ground: 15,
} as const;

// Значения cosφ по умолчанию для разных типов нагрузок
export const DEFAULT_POWER_FACTOR = {
  power: 0.8,
  lighting: 0.95,
} as const;

// Наименования материалов
export const MATERIAL_LABELS = {
  copper: 'Медь',
  aluminum: 'Алюминий',
} as const;

// Наименования типов сети
export const NETWORK_TYPE_LABELS = {
  'three-phase': 'Трёхфазная',
  'single-phase': 'Однофазная',
} as const;

// Наименования типов нагрузки
export const LOAD_TYPE_LABELS = {
  power: 'Силовая',
  lighting: 'Осветительная',
} as const;

// Наименования способов прокладки
export const INSTALLATION_METHOD_LABELS = {
  air: 'На воздухе',
  ground: 'В земле',
  pipe: 'В трубе',
  tray: 'В лотке',
  bundle: 'Пучком',
} as const;

// Наименования типов линии
export const LINE_TYPE_LABELS = {
  cable: 'Кабельная линия',
  overhead: 'Воздушная линия',
} as const;

// Наименования типов изоляции
export const INSULATION_TYPE_LABELS = {
  pvc: 'ПВХ',
  xlpe: 'СПЭ (сшитый полиэтилен)',
  paper: 'Бумажная',
} as const;
